<div class="modal-body">
    <button type="button" id="close-cart-modal" class="close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
    <div>
        <img lazyLoad="{{srcImg+imageSrc}}" class="image-responsive image-zoom"
            [alt]="imageAlt" src="{{srcImg+imageSrc}}">
    </div>
</div>